// extracted by mini-css-extract-plugin
export default {"barTitle":"home_barTitle__c6rWE","homeTitle":"home_homeTitle__DYFyW"};